import { useQuery } from '@tanstack/react-query';
import { getSessions, getSessionEvents, type Session, type PaginatedResponse } from '../api/client';

interface UseSessionsParams {
  page?: number;
  pageSize?: number;
  dateRange?: string;
  device?: string;
  hasErrors?: boolean;
  hasRageClicks?: boolean;
  url?: string;
  customerId?: string;
  emailHash?: string;
  phoneHash?: string;
  /** when false, the query is held back (e.g. while a typed identity is still being hashed) */
  enabled?: boolean;
}

export function useSessions(params: UseSessionsParams = {}) {
  const { enabled = true, ...apiParams } = params;
  return useQuery<PaginatedResponse<Session>, Error>({
    queryKey: ['sessions', apiParams],
    queryFn: () => getSessions(apiParams),
    enabled,
  });
}

export function useSessionEvents(sessionId: string | undefined) {
  return useQuery({
    queryKey: ['session-events', sessionId],
    queryFn: () => getSessionEvents(sessionId!),
    enabled: !!sessionId,
  });
}
